import { checkIsStringEmpty } from "../../../../../../Common/modules/DataTypes/utils/strings";
import { customRequest } from "../../../../../../Common/modules/DataProvider/utils/DataProvider.utils";
import { isRequestSuccessful } from "../../../../../../../utils/common/common";
import {
  check_customer_existency_api,
  generate_otp_api,
} from "../../../constants/Onboarding.apis";
import {
  HTTP_METHODS,
  OTP_PURPOSE,
} from "../../../../../../Common/modules/DataProvider/constants/DataProvider.constants";
import { IOnboarding } from "../../../IOnboarding";

export const checkUserExistency = async ({
  email,
  phoneNumber,
  subDomain,
  loginWithEmail,
  countryCode,
}: IOnboarding.ICheckUserExistencyProps) => {
  try {
    if (checkIsStringEmpty(email) && checkIsStringEmpty(phoneNumber)) {
      return false;
    }
    const dialCode = countryCode?.split("+")[1]; // + is being changed to escape character, so send country code without +
    const params: IOnboarding.ICheckUserExistencyAPIParam = {
      sub_domain: subDomain,
      ...(loginWithEmail
        ? { email }
        : { phone_number: phoneNumber, country_code: dialCode }),
    };

    const response = await customRequest({
      endpoint: check_customer_existency_api,
      payload: params,
      skipAccessToken: true,
    });

    if (isRequestSuccessful(response?.status)) {
      return true;
    }
    throw new Error(response?.message);
  } catch (error) {
    console.error("Error in react lib checkUserExistency", error);
    throw error;
  }
};

export const generateOtp = async ({
  email,
  phoneNumber,
  subDomain,
  loginWithEmail,
  countryCode,
}: IOnboarding.IGenerateOtpProps) => {
  try {
    if (checkIsStringEmpty(email) && checkIsStringEmpty(phoneNumber)) {
      return false;
    }

    const payload: IOnboarding.IGenerateOtpAPIParam = {
      otp_purpose: OTP_PURPOSE.EUD_EMAIL_LOGIN,
      sub_domain: subDomain,
    };
    if (loginWithEmail) {
      payload.email = email;
    } else {
      payload.country_code = countryCode;
      payload.phone_number = phoneNumber;
      payload.otp_purpose = OTP_PURPOSE.EUD_PHONE_NUMBER_LOGIN;
    }
    const response = await customRequest({
      endpoint: generate_otp_api,
      payload,
      method: HTTP_METHODS.POST,
      skipAccessToken: true,
    });

    if (isRequestSuccessful(response?.status)) {
      return true;
    }
    throw new Error(response?.message);
  } catch (error) {
    console.error("Error in react lib generateOtp", error);
    throw error;
  }
};
